<div class="container-fluid mb-5">
    <div class="row">
        <div class="col-12 mt-2">
            <form autocomplete="off" [formGroup]="form">
                <div class="row">
                    <div class="col-12">
                        <div class="card mb-3 bg-2">
                            <div class="card-body">
                                <div class="row mt-4 d-flex">
                                    <div class="col-2 col-sm-2 col-md-2 col-xl-2 tipoCadastro">
                                        <mat-form-field class="small-input" appearance="outline">
                                            <mat-label>Tipo Cadastro</mat-label>
                                            <mat-select formControlName="tipoCadastro" required>
                                                <mat-option value=""></mat-option>
                                                <mat-option *ngFor="let s of tiposCadastro" [value]="s">
                                                    {{ s }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-2 col-md-2 col-xl-2 small-input col  dataInicio">
                                        <lib-datepicker-day [schema]="dataInicioSchema"></lib-datepicker-day>
                                    </div>
                                    <div class="col-sm-2 col-md-2 col-xl-2 small-input col dataFim">
                                        <lib-datepicker-day
                                            [schema]="dataFimSchema"
                                        ></lib-datepicker-day>
                                    </div>
                                    <div class="col-2 col-sm-2 col-md-2 col-xl-2 usuario">
                                        <mat-form-field class="small-input" appearance="outline">
                                            <mat-label>Usuário</mat-label>
                                            <input class="medium-input" matInput type="text" formControlName="usuario">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-2 col-sm-2 col-md-2 col-xl-2 usuario-autorizacao">
                                        <mat-form-field class="small-input" appearance="outline">
                                            <mat-label>Usuário autorização</mat-label>
                                            <input class="medium-input" matInput type="text" formControlName="usuarioAutorizacao">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-2 col-md-2 col-xl-2 small-input col  acao">
                                        <mat-form-field class="small-input" appearance="outline">
                                            <mat-label>Ação</mat-label>
                                            <mat-select formControlName="acao">
                                                <mat-option value=""></mat-option>
                                                <mat-option *ngFor="let Ti of tiposCommit" [value]="Ti.id">
                                                    {{ Ti.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class=" col-sm-2 col-md-2 col-xl-2 small-input col identificador">
                                        <mat-form-field class="small-input" appearance="outline">
                                            <mat-label>Identificador</mat-label>
                                            <input class="small-input" matInput type="text" formControlName="identificador">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-4 col-sm-4 col-md-4 col-xl-4 descricao">
                                        <mat-form-field class="medium-input" appearance="outline">
                                            <mat-label>Descrição</mat-label>
                                            <input class="medium-input" matInput type="text" formControlName="descricao">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer clearfix">
                                <div class="d-flex flex-roe justify-content-end">
                                    <div class="pr-3">
                                        <button
                                            mat-raised-button
                                            color="primary"
                                            (click)="page$.next(1)"
                                            [disabled]="form.invalid || (loading$ | async)"
                                            label="Pesquisar"
                                            type="submit"
                                            title="Pesquisar"
                                            aria-label="left">
                                            <loading-icon
                                                class="align-content-center"
                                                [btnLabel]="'Pesquisar'"
                                                [loading]="loading$ | async"
                                            ></loading-icon>
                                        </button>
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <app-total-table [showRegistersPerPage]="true" (onChange)="updateItensPerPage($event)" [totalRegistros]="this.totalRegistros"></app-total-table>
            <table
                class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
                <thead>
                <tr>
                    <th>Data/Hora</th>
                    <th>Usuário</th>
                    <th>Usuário Autorização</th>
                    <th>Identificador</th>
                    <th>Tipo Cadastro</th>
                    <th>Ação</th>
                    <th>Descrição</th>
                    <th class="text-center">Ações</th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let audit of auditorias">
                    <tr class="element-row">
                        <td>{{ audit.timestamp | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                        <td>{{ audit.usuario }}</td>
                        <td>{{audit.autorizador}}</td>
                        <td>{{ audit.identificador }}</td>
                        <td>{{ audit.tipoCadastro }}</td>
                        <td>{{ audit.acao.name }}</td>
                        <td>{{audit.descricao}}</td>
                        <td class="pt-1 pb-1">
                          <div class="d-flex flex-row justify-content-center">
                            <div class="pr-2">
                              <button type="button" mat-icon-button (click)="showDetails(audit)" title="Mostrar detalhes">
                                <i class="fas fa-search" aria-hidden="true"></i>
                              </button>
                            </div>
                            <div>
                              <button type="button" mat-icon-button (click)="showDiff(audit)"
                                    title="Mostrar alterações" [disabled]="disableDiff(audit)">
                                <i class="fas fa-code-branch" aria-hidden="true"></i>
                            </button>
                            </div>
                          </div>
                        </td>
                    </tr>
                </ng-container>
                </tbody>
            </table>
        </div>
    </div>
    <div class="d-flex justify-content-center">
        <maps-pagination
            [pageNumber]="page$"
            [items]="paginationTotalPage"
            *ngIf="paginationTotalPage && paginationTotalPage > 0"
            (pageSend)="receiverPage($event)"
        ></maps-pagination>
    </div>
</div>
